import { useTranslation } from 'react-i18next';
import type { ContactOption } from '@/entities/contacts';

interface ContactDetailsProps {
  contact: ContactOption;
}

export const ContactDetails = ({ contact }: ContactDetailsProps) => {
  const { t } = useTranslation();

  return (
    <div className="mt-4 p-4 rounded-lg bg-green-50 border border-green-100 animate-in fade-in slide-in-from-top-2 duration-300">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <div className="text-[10px] font-bold text-muted-foreground uppercase tracking-wider mb-1">
            {`${t('contact.name.desc')} / ${t('contact.job.title.label')}`}
          </div>
          <div className="text-sm font-medium text-foreground">
            {contact.name} {contact.jobTitle ? `/ ${contact.jobTitle}` : ''}
          </div>
        </div>
        <div className="grid grid-cols-2 gap-4">
          <div>
            <div className="text-[10px] font-bold text-muted-foreground uppercase tracking-wider mb-1">
              {t('contact.email.label')}
            </div>
            <div className="text-sm font-medium text-muted-foreground break-all">{contact.email || '-'}</div>
          </div>
          <div>
            <div className="text-[10px] font-bold text-muted-foreground uppercase tracking-wider mb-1">
              {t('contact.phone.label')}
            </div>
            <div className="text-sm font-medium text-muted-foreground">{contact.phone || '-'}</div>
          </div>
        </div>
      </div>
    </div>
  );
};
